/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PageResourceMode {
    Static = 'static',
    Dynamic = 'dynamic',
    Scripted = 'scripted'
}

export function PageResourceModeFromJSON(json: any): PageResourceMode {
    return PageResourceModeFromJSONTyped(json, false);
}

export function PageResourceModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageResourceMode {
    return json as PageResourceMode;
}

export function PageResourceModeToJSON(value?: PageResourceMode | null): any {
    return value as any;
}

